import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { getStoredSession, type SessionState } from '../lib/auth-client';

interface SessionContextValue {
  session: SessionState | null;
  setSession: (s: SessionState | null) => void;
}

const SessionContext = createContext<SessionContextValue | null>(null);

export function SessionProvider({ children }: { children: ReactNode }): JSX.Element {
  const [session, setSession] = useState<SessionState | null>(() => getStoredSession());

  // Listen to storage events for cross-tab logout.
  useEffect(() => {
    const handler = (): void => {
      setSession(getStoredSession());
    };
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('storage', handler);
    };
  }, []);

  return (
    <SessionContext.Provider value={{ session, setSession }}>{children}</SessionContext.Provider>
  );
}

export function useSession(): SessionContextValue {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used inside SessionProvider');
  return ctx;
}
